import types from './types';

export const initialState = {
    shownImpressions: {},
    initialized: false,
    isSmartContentReady: false,
};

const reducers = (state = initialState, { type, payload }) => {
    switch (type) {
        case types.SET_PEERIUS_DATA:
            return { ...state, ...payload };

        case types.CLEAR_PEERIUS_DATA:
            return initialState;

        case types.SET_RECOMMENDATIONS_BY_WIDGETS:
            return {
                ...state,
                recommendationsByWidgets: payload.reduce(
                    (acc, curr) => ({
                        ...acc,
                        [curr.position]: curr,
                    }),
                    state.recommendationsByWidgets,
                ),
                initialized: true,
            };

        case types.SET_SMART_CONTENT:
            return {
                ...state,
                smartContent: payload.creatives.reduce(
                    (acc, curr) => ({
                        ...acc,
                        [curr.position]: {
                            position: curr.position,
                            ids: curr.html,
                            peeriusId: curr.id,
                        },
                    }),
                    state.smartContent,
                ),
                isSmartContentReady: true,
            };

        case types.SEND_IMPRESSIONS:
            return {
                ...state,
                shownImpressions: payload.reduce(
                    (acc, curr) => ({ ...acc, [curr]: curr }),
                    state.shownImpressions,
                ),
            };

        default:
            return state;
    }
};

export default reducers;
